// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1DnsA","amount":"Amount_amount__2C5j_","tip":"Amount_tip__1UN0V","tipHeader":"Amount_tipHeader__2VOit","tipsWrap":"Amount_tipsWrap__1_NVa"};